import { StepHandle } from "..";
import { InformationMessageType, moduleStepService, WorkflowManager } from "../..";
import { ModuleStepData, Step } from "../../types";
import { renderTextTemplateForWorkflow } from "../../util/text";

export class ModuleStepHandle extends StepHandle<ModuleStepData> {
    constructor(manager: WorkflowManager, step: Step<ModuleStepData>, tags: string[]) {
        super(manager, step, tags);
    }

    async selectVariant() {
        console.info("Text Modules don't support variants.");
        //noop
    }

    /**
     * Return the remaining amount of characters that
     * the user is allowed to add, or undefined if there is no limit.
     */
    getCharactersRemaining(): number | undefined {
        const limit = this.step.data.maxLength;
        if (limit === undefined) {
            return undefined;
        }
        const text = renderTextTemplateForWorkflow(this.getText(), this.manager);
        return limit - text.length;
    }

    /**
     * Return the maximum characters allowed for
     * this step, or undefined if there is no limit.
     */
    getCharacterLimit(): number | undefined {
        return this.step.data.maxLength;
    }

    getText(): string {
        return this.manager.getStepStorage(this.step.stepName)?.text || "";
    }

    setText(value: string) {
        moduleStepService.changeText(this.step, value, this.manager, (error) => {
            if (error) {
                const errors = [
                    ...this.manager.getInformationResults(),
                    {
                        message: error,
                        messageType: InformationMessageType.Error,
                        stepID: this.step.stepName,
                    },
                ];
                this.manager.setInformationResults(errors);
            } else {
                const results = this.manager.getInformationResults().filter((r) => r.stepID !== this.step.stepName);
                this.manager.setInformationResults(results);
            }
        });
    }
}
